import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import t from "prop-types";
import * as Icon from "react-feather";

import { P } from "../../atoms/Texts";

const Line = styled.div`
  background: ${(props) => (props.active ? "#442ED0" : "#cecddd")};
  height: 1px;

  &:first-of-type,
  &:last-of-type {
    display: none;
  }
`;

const Step = styled.div`
  background: ${(props) => (props.active ? "#442ED0" : "transparent")};
  color: ${(props) => (props.active ? "#ffffff" : "#CECDDD")};
  border: ${(props) => (props.active ? "2px solid #442ED0" : "2px solid #CECDDD")};

  > p.title {
    color: ${(props) => (props.active ? "#413e53" : "#CECDDD")};
    position: absolute;
    top: 50px;
    font-size: 10px;
    font-weight: 600;
    z-index: 1;
  }
`;

const Stepper = ({ steps, changeStep, activeStep, disableClick }) => {
  const [titleWidth, setTitleWidth] = useState(null);
  const titleText = useRef(null);

  useEffect(() => {
    if (titleText.current) {
      setTitleWidth(
        (titleText.current.getBoundingClientRect().width / 2).toFixed(1),
      );
    }
  }, []);

  return (
    <div className="flex items-center px-10">
      {steps.map((step, idx) => (
        <React.Fragment key={idx}>
          <Line className="flex-grow" active={step.value === activeStep} />
          <div
            onClick={
              disableClick || step.disableClick
                ? () => {}
                : () => changeStep(step.value)
            }
            className="flex-shrink-0 cursor-pointer"
          >
            <Step
              active={step.value === activeStep}
              titleWidth={titleWidth}
              className="h-10 w-10 rounded-full flex items-center justify-center relative"
            >
              {step.value < activeStep ? (
                <Icon.Check color="#442ED0" />
              ) : (
                <>
                  <P color="inherit" smallSize="14px">
                    {step.value}
                  </P>
                  <P
                    ref={titleText}
                    color="#413E53"
                    smallSize="10px"
                    fontSize="10px"
                    className="font-semibold title my-0 whitespace-pre text-center"
                  >
                    {step.title}
                  </P>
                </>
              )}
            </Step>
          </div>
          <Line className="flex-grow" active={step.value <= activeStep} />
        </React.Fragment>
      ))}
    </div>
  );
};

Stepper.propTypes = {
  steps: t.array.isRequired,
};

export default Stepper;
